import axios from '../utilities/axios'

const UBI_TICKET = 'ubi_v1'

function activateGame(ticket, activationKey, contentId, couponCode) {
  return axios.post('/api/v1/uplay/content/activate', {
    ticket,
    activationKey,
    contentId,
    couponCode,
  })
}

function setUserUplayTicket(ticket) {
  return axios.post('/api/v1/uplay/ticket', { ticket })
}

function verifyUserUplayTicket(ticket) {
  return axios.post('/api/v1/uplay/ticket/verify', { ticket })
}

function saveUserTicket(ticket) {
  localStorage.setItem(UBI_TICKET, ticket)
}

function getUserTicket() {
  const ticket = localStorage.getItem(UBI_TICKET)
  return ticket || null
}

function removeUserTicket() {
  return localStorage.removeItem(UBI_TICKET)
}

export default {
  activateGame,
  setUserUplayTicket,
  verifyUserUplayTicket,
  saveUserTicket,
  getUserTicket,
  removeUserTicket,
}
